/*
  Lightbox — vanilla JS, native <dialog>.

  Activates on any element with [data-lightbox-item]. Two modes:
  - Standalone: single image, no nav arrows
  - Group: links sharing data-lightbox-group="<id>" → arrow navigation between items

  Markup contract on triggers:
    <a data-lightbox-item href="<bigurl>" data-lightbox-group="<id>" data-caption="<text>">…</a>

  Markup contract on the dialog (rendered by snippets/lightbox.liquid):
    <dialog data-drh-lightbox class="drh-lightbox">
      <div class="drh-lightbox__inner">
        <button data-lightbox-close>…</button>
        <button data-lightbox-prev>…</button>
        <img data-lightbox-img>
        <button data-lightbox-next>…</button>
        <div data-lightbox-caption></div>
      </div>
    </dialog>

  Body scroll lock: owned by the shared overlay manager.
*/

(function () {
  'use strict';

  function init() {
    var dialog = document.querySelector('[data-drh-lightbox]');
    if (!dialog || typeof dialog.showModal !== 'function') return;

    var imgEl = dialog.querySelector('[data-lightbox-img]');
    var captionEl = dialog.querySelector('[data-lightbox-caption]');
    var prevBtn = dialog.querySelector('[data-lightbox-prev]');
    var nextBtn = dialog.querySelector('[data-lightbox-next]');
    var closeBtn = dialog.querySelector('[data-lightbox-close]');
    var currentItems = [];
    var currentIndex = 0;
    var openerEl = null;
    var overlayLayer = window.DrhOverlayManager
      ? window.DrhOverlayManager.create({
          root: dialog,
          panel: dialog,
          modal: true,
          native: true,
          fallbackFocus: function () { return openerEl; }
        })
      : null;

    function showItem(index) {
      if (!currentItems.length) return;
      currentIndex = (index + currentItems.length) % currentItems.length;
      var item = currentItems[currentIndex];
      imgEl.setAttribute('src', item.href);
      imgEl.setAttribute('alt', item.alt || '');
      captionEl.textContent = item.caption || '';
      var multi = currentItems.length > 1;
      prevBtn.hidden = !multi;
      nextBtn.hidden = !multi;
    }

    function open(items, index, opener) {
      currentItems = items;
      openerEl = opener || null;
      showItem(index);
      dialog.showModal();
      if (overlayLayer) {
        overlayLayer.open({ trigger: openerEl });
      } else if (window.__scrollLock && typeof window.__scrollLock.lock === 'function') {
        window.__scrollLock.lock(dialog);
      }
    }

    function close() {
      if (dialog.open) dialog.close();
    }

    dialog.addEventListener('close', function () {
      if (overlayLayer) {
        overlayLayer.close({ fallbackFocus: function () { return openerEl; } });
      } else if (window.__scrollLock && typeof window.__scrollLock.unlock === 'function') {
        window.__scrollLock.unlock(dialog);
      }
      imgEl.removeAttribute('src');
      captionEl.textContent = '';
      if (!overlayLayer && openerEl && typeof openerEl.focus === 'function') {
        openerEl.focus();
      }
      openerEl = null;
      currentItems = [];
    });

    closeBtn.addEventListener('click', close);

    // Click on backdrop (outside .drh-lightbox__inner) closes
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) close();
    });

    prevBtn.addEventListener('click', function () {
      showItem(currentIndex - 1);
    });

    nextBtn.addEventListener('click', function () {
      showItem(currentIndex + 1);
    });

    document.addEventListener('keydown', function (event) {
      if (!dialog.open) return;
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        showItem(currentIndex - 1);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        showItem(currentIndex + 1);
      }
    });

    // Touch swipe (mobile)
    var touchStartX = null;
    dialog.addEventListener('touchstart', function (event) {
      if (event.touches.length === 1) touchStartX = event.touches[0].clientX;
    }, { passive: true });

    dialog.addEventListener('touchend', function (event) {
      if (touchStartX === null) return;
      var dx = event.changedTouches[0].clientX - touchStartX;
      touchStartX = null;
      if (Math.abs(dx) > 50 && currentItems.length > 1) {
        showItem(currentIndex + (dx < 0 ? 1 : -1));
      }
    }, { passive: true });

    // Delegated click handler on triggers
    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-lightbox-item]');
      if (!trigger) return;
      event.preventDefault();
      var group = trigger.getAttribute('data-lightbox-group');
      var items;
      var startIndex = 0;
      if (group) {
        var groupTriggers = document.querySelectorAll(
          '[data-lightbox-item][data-lightbox-group="' + CSS.escape(group) + '"]'
        );
        items = Array.prototype.map.call(groupTriggers, triggerToItem);
        startIndex = Array.prototype.indexOf.call(groupTriggers, trigger);
        if (startIndex < 0) startIndex = 0;
      } else {
        items = [triggerToItem(trigger)];
      }
      open(items, startIndex, trigger);
    });
  }

  function triggerToItem(trigger) {
    var img = trigger.querySelector('img');
    return {
      href: trigger.getAttribute('href'),
      alt: trigger.getAttribute('data-lightbox-alt') || (img && img.getAttribute('alt')) || '',
      caption: trigger.getAttribute('data-caption') || '',
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
